const ALL_HOURS_MATCH = "ALL_HOURS_MATCH";
const MON_THROUGH_SAT_HOURS_MATCH = "MON_THROUGH_SAT_HOURS_MATCH";
const WEEKEND_HOURS_MATCH = "WEEKEND_HOURS_MATCH";
const NO_HOURS_MATCH = "NO_HOURS_MATCH";
const MODULE_SETTINGS_WAREHOUSES_PAGE_URL = "warehousespagebaseurl";
const MODULE_SETTINGS_WAREHOUSES_PAGE_URL_SUFFIX = "warehousespageurlsuffix";
const DEFAULT_BASE_URL = "/warehouse-locations/";
const BUSINESS_CENTER_SUBTYPE_CODE = "Business Center";
const SHOWROOM_REGION_CODE = "HS";
const WAREHOUSE_TYPES = {
  BUSINESS_CENTER: "businessCenter",
  STANDARD: "standard",
  SHOWROOM: "showroom"
};
const BUSINESS_CENTER_REGION = "BD";
const BUSINESS_CENTER_REGION_CA = "CB";
const FILTER_OPTION_IDS = {
  BUSINESS_CENTER: "businesscenteroption",
  GAS_STATION: "gasstationoption",
  CAR_WASH: "carwashoption",
  TIRE_CENTER: "tirecenteroption",
  FOOD_COURT: "foodcourtoption",
  HEARING_AID: "hearingaidoption",
  OPTICAL: "opticaloption",
  PHARMACY: "pharmacyoption"
};
const FILTER_PARAM_TYPES = {
  WAREHOUSE_LOCATOR_MOBILE_API: "warehouseLocatorMobileApi",
  WAREHOUSE_LOCATIONS_PAGE: "warehouseLocationsPage"
};
export {
  ALL_HOURS_MATCH,
  BUSINESS_CENTER_REGION,
  BUSINESS_CENTER_REGION_CA,
  BUSINESS_CENTER_SUBTYPE_CODE,
  DEFAULT_BASE_URL,
  FILTER_OPTION_IDS,
  FILTER_PARAM_TYPES,
  MODULE_SETTINGS_WAREHOUSES_PAGE_URL,
  MODULE_SETTINGS_WAREHOUSES_PAGE_URL_SUFFIX,
  MON_THROUGH_SAT_HOURS_MATCH,
  NO_HOURS_MATCH,
  SHOWROOM_REGION_CODE,
  WAREHOUSE_TYPES,
  WEEKEND_HOURS_MATCH
};
